import { render, staticRenderFns } from "./mineOrder.vue?vue&type=template&id=52d60a97&scoped=true"
import script from "./mineOrder.vue?vue&type=script&lang=js"
export * from "./mineOrder.vue?vue&type=script&lang=js"
import style0 from "./mineOrder.vue?vue&type=style&index=0&id=52d60a97&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d60a97",
  null
  
)

export default component.exports